export default path => (/^https?:\/\//i.test(path) ? path : `${process.env.VUE_APP_API_HOST}${path}`);
